import { useState, useEffect } from 'react'
import { Outlet, Link, useSearchParams  } from 'react-router-dom'
import { Calendar, Leaf } from 'lucide-react'
import api from '../services/api'

export default function Layout() {
  const [searchParams] = useSearchParams() 
  const isEmbed = searchParams.get('embed') === 'true' 

  // On stocke toute la donnée du widget (qui contient le profil, les couleurs et les filtres de confidentialité)
  const [widgetData, setWidgetData] = useState(null)

  useEffect(() => {
      const fetchProfile = () => {
          api.get('/api/workspaces/widget-data')
             .then(res => setWidgetData(res.data))
             .catch(() => {})
      };
      
      fetchProfile();
      
      window.addEventListener('workspaceChanged', fetchProfile);
      return () => window.removeEventListener('workspaceChanged', fetchProfile);
  }, []) 


  // Extraction sécurisée des données avec valeurs par défaut
  const profile = widgetData?.profile || { admin_name: "Chargement...", admin_title: "" }
  const primaryColor = widgetData?.landing_config?.theme?.text_color || '#7d9668'
  const bgColor = widgetData?.landing_config?.theme?.bg_color || '#fdfdf9'

  // Détection réactive de l'Espace Commercial principal
  const isSaasRoot = !api.defaults.headers.common['X-Workspace-Id']

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: isEmbed ? 'transparent' : (isSaasRoot ? '#fdfdf9' : bgColor) }}>
      {/* Header conditionnel */}
      {!isEmbed && !isSaasRoot && (
        <header className="bg-white shadow-sm border-b border-gray-100">
          <div className="max-w-5xl mx-auto px-4 py-4 flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
              <div className="w-10 h-10 rounded-full flex items-center justify-center shadow-inner" style={{ backgroundColor: primaryColor + '15', color: primaryColor }}>
                <Leaf className="w-5 h-5" />
              </div>
              <div>
                <h1 className="text-xl font-serif font-bold" style={{ color: primaryColor }}>{profile.admin_name}</h1>
                <p className="text-xs text-gray-500 font-bold">{profile.admin_title}</p>
              </div>
            </Link>
            
            <Link 
              to="/booking" 
              className="flex items-center gap-2 px-5 py-2.5 rounded-xl text-white font-bold transition-transform hover:-translate-y-0.5 shadow-md"
              style={{ backgroundColor: primaryColor }}
            >
              <Calendar className="w-4 h-4" />
              <span className="hidden sm:inline">Prendre RDV</span>
            </Link>
          </div>
        </header>
      )}

      {/* Main content */}
      <main className="flex-1">
        <Outlet />
      </main>

      {/* Footer conditionnel */}
      {!isEmbed && !isSaasRoot && (
        <footer className="border-t border-gray-200 py-8 mt-12" style={{ backgroundColor: primaryColor + '05' }}>
          <div className="max-w-5xl mx-auto px-4 text-center">
            <div className="flex justify-center gap-2 text-2xl mb-4 opacity-40">
              🌸 🌿 🌸
            </div>
            <p className="text-sm font-bold" style={{ color: primaryColor }}>
              © {new Date().getFullYear()} {profile.admin_name} — {profile.admin_title}
            </p>
            <p className="text-gray-500 text-xs mt-3 flex flex-col items-center gap-1">
              {profile.phone && <span>{profile.phone}</span>}
              {profile.email && (
                <a href={`mailto:${profile.email}`} className="hover:underline transition-all" style={{ textDecorationColor: primaryColor, color: primaryColor }}>
                  {profile.email}
                </a>
              )}
            </p>
            <div className="mt-6">
              <Link to="/mentions-legales" className="text-xs text-gray-400 hover:text-gray-600 underline">Mentions Légales & CGV</Link>
            </div>
          </div>
        </footer>
      )}
    </div>
  )
}
